import React from 'react';

export const CurrentCompanyContext = React.createContext({});
